module.exports = __webpack_public_path__ + "img/date-icon.a9cc6fee.svg";